module.exports = __webpack_public_path__ + "img/illustration-3.4c512526.svg";